import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getCrops = async (params) => {
	const { data } = await axios.get(`${API}/admin/crops`, { params });
	return data;
};
